const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ constants
const {
    ACC_NUMBER_LENGTH,
    ACC_NUMBER_REGEX,
    BENEFICIARY_BANK_OPTION_BIC,
    BENEFICIARY_BANK_OPTION_NAME
} = require('constants/index');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { isSepa } = require('utilities/transfersHelper');
// @ components
const AddBeneficiaryBankDetails = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiaryStep1/addBeneficiaryBankDetails');
const { OKInput } = require('commonsComponents/OKInput');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { InputSafe } = require('commonsComponents/inputSafe');
const MaskedIban = require('components/maskedIban/maskedIban');
const MaskedBic = require('components/maskedBic/maskedBic');
const { IbanModal } = require('components/ibanModal/ibanModal');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@actions
const bankEntityActions = require('actions/bankEntity');

class AddBeneficiaryAccounts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accountNumber: props.immAddBeneficiary.get('accountNumber')
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleAccountNumberChange = this.handleAccountNumberChange.bind(this);
        this.handleAccountNumberBlur = this.handleAccountNumberBlur.bind(this);
        this.handleModalToggle = this.handleModalToggle.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { getBankNameFromIban, getBankNameFromBic } = this.props;
        if ( this.props.immAddBeneficiary.get('accountNumber') !== nextProps.immAddBeneficiary.get('accountNumber')) {
            // This is the case when add beneficiary form is filled with existing beneficiary to be able to edit it.
            this.setState({
                accountNumber: nextProps.immAddBeneficiary.get('accountNumber')
            });
        }

        if (nextProps.immAddBeneficiary.get('ibanIsValid')
            && nextProps.immAddBeneficiary.get('iban') !== this.props.immAddBeneficiary.get('iban')) {
            getBankNameFromIban(nextProps.immAddBeneficiary.get('iban'));
        } else if (nextProps.immAddBeneficiary.get('bicIsValid')
            && nextProps.immAddBeneficiary.get('bic') !== this.props.immAddBeneficiary.get('bic')) {
            getBankNameFromBic(nextProps.immAddBeneficiary.get('bic'));
        }
    }

    buildBankEntity() {
        const { immAddBeneficiary, immBankEntity } = this.props;
        let bankEntitySection;

        if (immAddBeneficiary.get('ibanIsValid') || immAddBeneficiary.get('bicIsValid')) {
            const bankEntityLabel = formatText('transferSummary-bankEntityTitle');
            let bankEntityBody;
            if (immBankEntity.get('isLoading')) {
                bankEntityBody = (<LoadingSection />);
            } else {
                const bankEntityName = immBankEntity.get('bankName') || '-';
                bankEntityBody = (
                    <OKInput
                        label={bankEntityLabel}
                        value={bankEntityName}
                        disabled
                    />
                );
            }
            bankEntitySection = (
                <div className="add-beneficiary-step-one__form-section">
                    {bankEntityBody}
                </div>
            );

        }

        return bankEntitySection;
    }

    buildBankSection() {
        const { immAddBeneficiary, actions } = this.props;
        let content;

        if (immAddBeneficiary.get('bankOption') === BENEFICIARY_BANK_OPTION_BIC) {
            const labelBic = formatText('transferSummary-step1BeneficiaryBic').toUpperCase();

            const bicRequiredAlertVisible = immAddBeneficiary.get('bicIsDirty') && immAddBeneficiary.get('bic') === '';
            const bicWrongFormatAlertVisible = immAddBeneficiary.get('bicIsDirty') && !immAddBeneficiary.get('bicIsValid');
            let bicErrorMsg = formatText('transferSummary-step1BicIsInvalid');

            if (bicRequiredAlertVisible) {
                bicErrorMsg = formatText('transferSummary-requiredMessage', [labelBic]);
            }

            content = (
                <div className="add-beneficiary-step-one__form-section">
                    <MaskedBic
                        bic={immAddBeneficiary.get('bic')}
                        id="inp_AddBeneficiaryStep1_BeneficiaryBic"
                        label={labelBic}
                        callback={actions.setBeneficiaryBic}
                        errorState={bicRequiredAlertVisible || bicWrongFormatAlertVisible}
                        errorMessage={bicErrorMsg}
                    />
                </div>
            );
        } else {
            content = (
                <AddBeneficiaryBankDetails
                    immAddBeneficiary={immAddBeneficiary}
                    actions={actions}
                />
            );
        }

        return content;
    }

    errorMessage = (iban, ibanRequiredAlertVisible, labelIban, countryCode) => {
        if (ibanRequiredAlertVisible) {
            let labelIbanTextSliced = labelIban.slice(labelIban.indexOf('IBAN'));
            return formatText('transferSummary-requiredMessage', [labelIbanTextSliced]);
        } else if (iban && countryCode && countryCode.toUpperCase() == 'ES' && iban.length == 20 && iban.match(/^[\d]{2}/)) {
            return formatText('transferSummary-step1CCIsInvalid');
        }
        return formatText('transferSummary-step1IbanIsInvalid');
    }

    buildIbanSection() {
        const { immAddBeneficiary, actions } = this.props;
        const countryCode = immAddBeneficiary.get('country');
        const iban = immAddBeneficiary.get('iban');
        const labelIban = formatText('transferSummary-step1BeneficiaryIBANAccount');
        const ibanIsDirty = immAddBeneficiary.get('ibanIsDirty');
        const ibanRequiredAlertVisible = ibanIsDirty && iban === '';
        const ibanWrongFormatAlertVisible = ibanIsDirty && !immAddBeneficiary.get('ibanIsValid');

        return (
            <div className="add-beneficiary-step-one__form-section">
                <MaskedIban
                    id="inp_AddBeneficiaryStep1_BeneficiaryIban"
                    label={labelIban}
                    iban={iban}
                    onClickInfo={this.handleModalToggle}
                    callback={actions.setBeneficiaryIban}
                    errorState={ibanRequiredAlertVisible || ibanWrongFormatAlertVisible}
                    errorMessage={this.errorMessage(iban, ibanRequiredAlertVisible, labelIban, countryCode)}
                    countryCode={countryCode}
                />
            </div>
        );
    }

    buildOutsideSepaSection() {
        const { immAddBeneficiary, actions } = this.props;

        const radioButtonsSection = this.buildRadioButtons();
        const bankSection = this.buildBankSection();

        const labelAccountNumber = formatText('transferSummary-step1BeneficiaryAccountNumber').toUpperCase();

        const accountNumberRequiredAlertVisible = immAddBeneficiary.get('accountNumberIsDirty') && immAddBeneficiary.get('accountNumber') === '';
        const accountNumberFormatAlertVisible = immAddBeneficiary.get('accountNumberIsDirty') && !immAddBeneficiary.get('accountNumberIsValid');
        let accountNumberErrorMsg = formatText('transferSummary-step1AccountNumberIsInvalid');

        if (accountNumberRequiredAlertVisible) {
            accountNumberErrorMsg = formatText('transferSummary-requiredMessage', [labelAccountNumber]);
        }

        return (
            <div className="add-beneficiary-accounts__outside-sepa">
                <div className="add-beneficiary-step-one__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelAccountNumber}
                        value={this.state.accountNumber}
                        onChange={this.handleAccountNumberChange}
                        onBlur={this.handleAccountNumberBlur}
                        maxLength={ACC_NUMBER_LENGTH}
                        errorState={accountNumberRequiredAlertVisible || accountNumberFormatAlertVisible}
                        errorMessage={accountNumberErrorMsg}
                    />
                </div>
                <div className="add-beneficiary-step-one__form-section">
                    <label
                        id="lbl_AddBeneficiaryStep1_BeneficiaryaccountNumber"
                        className="add-beneficiary-step-one__label"
                    >
                        <FormattedText value="transferSummary-step1BeneficiaryBank" />
                    </label>
                    <RadioButtonGroup
                        name="bank-option"
                        idPrefix="banks-option-radio"
                        selectedValue={immAddBeneficiary.get('bankOption')}
                        onChange={actions.handleBeneficiaryBankOption}
                    >
                        {radioButtonsSection}
                    </RadioButtonGroup>
                </div>
                {bankSection}
            </div>
        );
    }

    buildRadioButtons() {
        const options = [BENEFICIARY_BANK_OPTION_BIC, BENEFICIARY_BANK_OPTION_NAME];
        return options.map((id, index) => {
            let label = formatText(`transferSummary-step1BeneficiaryBankOption${id}`);
            return <RadioButton key={index} label={label} value={id} />;
        });
    }

    handleAccountNumberBlur(evt) {
        const accountNumber = evt.target.value.toUpperCase();
        const isValid = ACC_NUMBER_REGEX.test(accountNumber);

        this.setState(
            {
                accountNumber: accountNumber
            },
            () => {
                this.props.actions.setBeneficiaryAccountNumber(accountNumber, isValid);
            }
        );
    }

    handleAccountNumberChange(evt) {
        const accountNumber = evt.target.value.replace(/[^A-Z\d]/gi, ''); /* remove non numbers or letters */
        this.setState({
            accountNumber: accountNumber
        });
    }

    handleModalToggle() {
        const { actions } = this.props;
        actions.toggleIbanModal();
    }

    render() {
        const { immAddBeneficiary } = this.props;

        const insideSepa = isSepa(
            immAddBeneficiary.get('country'),
            immAddBeneficiary.get('currency')
        );
        const accountsSection = insideSepa
            ? this.buildIbanSection()
            : this.buildOutsideSepaSection();
        const ibanModal = <IbanModal onRequestClose={this.handleModalToggle} />;
        const bankEntitySection = this.buildBankEntity();

        return (
            <div className="add-beneficiary-accounts">
                {ibanModal}
                {accountsSection}
                {bankEntitySection}
            </div>
        );
    }
}

AddBeneficiaryAccounts.propTypes = {
    actions: PropTypes.object,
    immAddBeneficiary: PropTypes.object,
    immBankEntity: PropTypes.object,
    getBankNameFromIban: PropTypes.func.isRequired,
    getBankNameFromBic: PropTypes.func.isRequired
};

module.exports = connect(null, {
    getBankNameFromIban: bankEntityActions.getBankNameFromIban,
    getBankNameFromBic: bankEntityActions.getBankNameFromBic
})(AddBeneficiaryAccounts);
